import data from "../../../../../src/Checkbox.docs.json";
import * as React from 'react';
export default {
  data,
  React
};